import { useQuery } from '@tanstack/react-query';
import { streetsService } from '../service/streets.service';


export const useStreetsSearch = (query: string) => {
  return useQuery({
    queryKey: ['streets', 'search', query],
    queryFn: () => streetsService.search(query),
    enabled: query.length >= 2,
    staleTime: 1000 * 60 * 5, 
  });
};